import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

import { VariationProps } from './types';

export const TextSection = styled(FlexColumn)`
  width: 100%;

  padding: 24px;
  gap: 24px;

  align-items: center;

  ${QUERIES.largeTabletAndUp} {
    padding: 48px 48px 24px;
  }

  ${QUERIES.smallDesktopAndUp} {
    padding: 48px 162px 24px;
    gap: 32px;
  }
`;

export const Text = styled(FlexColumn)`
  align-items: center;
  gap: 24px;

  ${QUERIES.smallDesktopAndUp} {
    gap: 20px;
  }
`;

export const ImageWrapper = styled.div<Pick<VariationProps, 'imageSize'>>`
  position: relative;

  width: 100%;
  height: ${({ imageSize }) => (imageSize === 'big' ? '220px' : '180px')};

  ${QUERIES.laptopAndUp} {
    height: ${({ imageSize }) => (imageSize === 'big' ? '320px' : '220px')};
  }
`;
